
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
    return (
        <>
            <footer>
                <div>
                    <img className="w-full h-full" src={require("../../assets/image/top-footer.svg").default} alt="" />
                </div>
                <div className="footer-design py-[20px]">
                    <div className="container flex flex-col gap-[25px]">
                        <div className="f-col flex gap-[50px]">
                            <div className="w-100 w-[48%] flex flex-col gap-[15px]">
                                <div className="flex flex-col gap-[10px]">
                                    <div>
                                        <div className="font-header text-white text-[40px] font-bold">{t("Ligasos")}</div>
                                    </div>
                                    <p className="text-white leading-[1.1]">
                                        <span className="pl-[5px] w-fit px-[4px]">{t("Ligasos")}</span> 
                                        <span>
                                        {t("is a dedicated team of real estate experts and tech enthusiasts. We bring together years of industry experience and innovative technology to create a user-friendly platform that meets all your property needs")}
                                        </span>
                                    </p>
                                </div>
                                <div className="flex items-center gap-[5px]">
                                    <Link to={"https://www.facebook.com/Ligasosgroup?rdid=yYWlyY7rP2jgUenB&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19Cpmrz9sZ%2F#"}>
                                        <img className="w-[30px] h-[30px]" src={require("../../assets/icons/facebook-footer.svg").default} alt="" />
                                    </Link>
                                    <Link to={"https://www.instagram.com/ligasos/?igsh=eGdjdHpjdHZmajV1#"}>
                                        <img className="w-[30px] h-[30px]" src={require("../../assets/icons/insta-footer.svg").default} alt="" />
                                    </Link>
                                    {/* <Link to={""}>
                                        <img className="w-[30px] h-[30px]" src={require("../../assets/icons/tiktok-footer.svg").default} alt="" />
                                    </Link>
                                    <Link to={""}>
                                        <img className="w-[30px] h-[30px]" src={require("../../assets/icons/x-footer.svg").default} alt="" />
                                    </Link> */}
                                    <Link to={"wa.me/966570999395"}>
                                        <img className="w-[30px] h-[30px]" src={require("../../assets/icons/whtsapp-footer.svg").default} alt="" />
                                    </Link>
                                </div>
                            </div>
                            <div className="w-100 f-col w-[48%] flex gap-[40px] justify-end">
                                <div className="flex flex-col gap-[20px]">
                                    <div className="w-fit flex flex-col w-fit-res">
                                        <div className="w-fit text-[25px] text-white font-bold capitalize">{t("quick links")}</div>
                                    </div>
                                    <ul className="flex flex-col">
                                        <Link to={"/"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("Home")}</span>
                                            </li>
                                        </Link>
                                        <Link to={"/about"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("About us")}</span>
                                            </li>
                                        </Link>
                                        <Link to={"/services"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("Services")}</span>
                                            </li>
                                        </Link>
                                        <Link to={"/testimonials"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("Testimonials")}</span>
                                            </li>
                                        </Link>
                                        <Link to={"/blog"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("Blog")}</span>
                                            </li>
                                        </Link>
                                        <Link to={"/faqs"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("Faqs")}</span>
                                            </li>
                                        </Link>
                                        <Link to={"/contact"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/arrow-footer.svg").default} alt="" />
                                                <span className="text-white">{t("Contact us")}</span>
                                            </li>
                                        </Link>
                                    </ul>
                                </div>
                                <div className="flex flex-col gap-[20px]">
                                    <div className="w-fit flex flex-col w-fit-res">
                                        <div className="w-fit text-[25px] text-white font-bold capitalize">{t("Contact us")}</div>
                                    </div>
                                    <ul className="flex flex-col gap-[7px]">
                                        <Link to={"tel:+966 57 099 9395"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/phone-footer.svg").default} alt="" />
                                                <span className="text-white">{t("KSA")} : </span>
                                                <span className="text-white dir-ltr">+966 57 099 9395</span>
                                            </li>
                                        </Link>
                                        <Link to={"tel:+90 544 141 00 90"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/phone-footer.svg").default} alt="" />
                                                <span className="text-white">{t("TR")} : </span>
                                                <span className="text-white dir-ltr">+90 544 141 00 90</span>
                                            </li>
                                        </Link>
                                        <Link to={"mailto:info@ligasos.com"}>
                                            <li className="flex items-center gap-[5px]">
                                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/email-footer.svg").default} alt="" />
                                                <span className="text-white">info@ligasos.com</span>
                                            </li>
                                        </Link>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="t-center f-col flex items-center justify-between text-white font-bold pt-[15px] border-t-[1px] border-t-white">
                            <div className="text-white font-bold">{t("Copyright ©️ 2025 ligasos. All Rights Reserved.")}</div>
                            <div className="flex items-center gap-[5px]">
                                <Link className="text-white font-bold" to={"/terms"}>{t("Terms of Service")}</Link>
                                <span>||</span>
                                <Link className="text-white font-bold" to={"/privacy"}>{t("Privacy Policy")}</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}